import { Component, Prop, Mixins } from 'vue-property-decorator';
import CommonProps from '@groot-components/shared/mixins/props';

/**
 * Image Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Image Address
     */
    @Prop({ default: null }) src!: string;

    /**
     * Image Alt
     */
    @Prop({ default: window.location.hostname }) alt!: string;

    /**
     * Image Width
     */
    @Prop({ default: null }) width!: string;

    /**
     * Image height
     */
    @Prop({ default: null }) height!: string;

    /**
     * Image min-width
     */
    @Prop({ default: null }) minWidth!: string;

    /**
     * Image min-height
     */
    @Prop({ default: null }) minHeight!: string;

    /**
     * Image max-width
     */
    @Prop({ default: null }) maxWidth!: string;

    /**
     * Image max-height
     */
    @Prop({ default: null }) maxHeight!: string;

    /**
     * Image Aspect Ratio
     */
    @Prop() ratio!: number | string;

    /**
     * Change image object-fit to contain. Default is cover.
     */
    @Prop({ type: Boolean }) contain!: boolean;

    /**
     * Image gray-scale value
     */
    @Prop({ type: Boolean }) grayScale!: boolean;

    /**
     * Add border-radius:50% to Image
     */
    @Prop({ type: Boolean }) circle!: boolean;

    /**
     * Image placeholder for empty state
     */
    @Prop({ type: String }) placeholder!: string;

    /**
     * Set transition onload image
     */
    @Prop({ type: String, default: 'fade' }) transition!: string;

    /**
     * Actionable Close Icon
     */
    @Prop({ type: Boolean }) closeable!: boolean;

    /**
     * Actionable Type mini
     */
    @Prop({ type: Boolean }) mini!: boolean;

    /**
     * Actionable Type full
     */
    @Prop({ type: Boolean }) full!: boolean;

    /**
     * Actionable Type itSelf
     */
    @Prop({ type: Boolean }) itSelf!: boolean;

    /**
     * Actionable text
     */
    @Prop({ type: String }) text!: string;

    /**
     * Action click
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop({ type: Function }) method!: any;

    /**
     * Icons library code name. here's a list of supported icons libraries:
     * 'mdi' - Material Design Icons - https://materialdesignicons.com/
     * 'fa' - Font Awesome - https://fontawesome.com/icons
     */
    @Prop({ type: String, default: 'fa' }) library!: string;

    /**
     * Prefix of the icon
     * Font Awesome prefix: 'fab', 'far', 'fas'.
     */
    @Prop({ type: String, default: 'fas' }) prefix!: string;

    /**
     * Icon size
     */
    @Prop({ type: String }) iconSize!: string;

    /**
     * hidden component when close
     */
    @Prop({ type: Boolean }) hiddenAble!: boolean;
}

export default Props;
